import { Component, computed, contentChildren, ChangeDetectionStrategy } from '@angular/core';
import { PageCommand, PageCommandComponent } from '../page-command/page-command.component';

@Component({
  selector: 'app-page-command-group',
  standalone: true,
  imports: [],
  templateUrl: './page-command-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-command-group.component.scss'
})
export class PageCommandGroupComponent {
  private contentCommands = contentChildren(PageCommandComponent);

  public commands = computed(() => this.contentCommands().map(command => {
      const permissions = command.requiredPermissions().split(',').map(x => x.trim()).filter(x => x.length > 0);
      return { name: command.name(), text: command.text(), icon: command.icon(), action: command.action(), type: command.type(), requiredPermissions: permissions, disabled: command.disabled() } as PageCommand;
    }));
}
